define('models/validator/email',["backbone",
        "models/validator/_base/basevalidator"
], function (Backbone, BaseValidator) {
    "use strict";

    return BaseValidator.extend({

        defaults: {
            validationType: (enums != undefined) ? enums.validationType.email : 5
        },

        validate: function(val) {
            val = val.trim();
            this.set('value', val);
            var code = this.validateHasValue(val);
            if ( this.isValid(code) ) {
                code = this.validateEmail(val);
            }
            
            this.set('validationCode', code);
            return code;
        },

        validateEmail: function(val) {
            var code,
            	emailRegex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

            if ( emailRegex.test(val) ) {
            	code = enums.validationCode.ok;
            } else {
            	code = enums.validationCode.incorrectFormat
            }
            return code;
        }
    });
});
